// @react
import React, { ReactElement } from 'react'
// @types
import { WorkFormValues } from 'modules/common/forms/types/work'
import { GetConstantsQueryResult } from 'lib/graphql/graphqlTypes'
// @libraries
import { Control, Controller } from 'react-hook-form'
// @components
import Grid from '@bit/atd.web.grid'
import Banner from '@bit/atd.web.banner'
import Select from '@bit/atd.web.select'
import Hidden from '@material-ui/core/Hidden'
import strings from 'lib/constants/strings'

type PropsType = {
  constantData?: GetConstantsQueryResult['data']
  control: Control<WorkFormValues>
  editing?: boolean
}

const WorkHiddenFields = ({
  constantData,
  control,
  editing,
}: PropsType): ReactElement => {
  /****************************************
   * GQL HOOKS
   *****************************************/

  const companySizeOptions =
    constantData?.constants.companySizeCodes.map((item: any) => {
      return {
        value: item.key,
        label: item.value,
      }
    }) || []

  const budgetOptions =
    constantData?.constants.budgetSizeCodes.map((item: any) => {
      return {
        value: item.key,
        label: item.value,
      }
    }) || []

  const directReportOptions =
    constantData?.constants.directReportCountCodes.map((item: any) => {
      return {
        value: item.key,
        label: item.value,
      }
    }) || []

  /****************************************
   * RENDER
   *****************************************/

  return (
    <>
      {/* Row 4 */}
      <Grid xs={12} item>
        <Banner fullWidth icon="lock-on">
          None of the following will be visible on your public profile:
        </Banner>
      </Grid>

      {/* Row 5 */}
      <Grid xs={12} sm={6} item>
        <Controller
          control={control}
          name="companySize"
          defaultValue={''}
          render={({ onChange, onBlur, value, name }) => (
            <Select
              native
              name={name}
              readOnly={!editing}
              label="Company Size"
              placeholder={strings.PROFILE.ACCESS.C_SIZE}
              onBlur={onBlur}
              onChange={onChange}
              value={value as string}
              options={companySizeOptions}
            />
          )}
        />
      </Grid>
      <Grid xs={12} sm={6} item>
        <Controller
          control={control}
          defaultValue={''}
          name="trainingBudget"
          render={({ onChange, onBlur, value, name }) => (
            <Select
              native
              name={name}
              readOnly={!editing}
              label="Training Budget"
              placeholder={strings.PROFILE.ACCESS.BUDGET}
              onBlur={onBlur}
              onChange={onChange}
              value={value as string}
              options={budgetOptions}
            />
          )}
        />
      </Grid>

      {/* Row 6 */}
      <Grid xs={12} sm={6} item>
        <Controller
          control={control}
          name="directReportCount"
          defaultValue={''}
          render={({ onChange, onBlur, value, name }) => (
            <Select
              native
              name={name}
              readOnly={!editing}
              label="Direct Report Count"
              placeholder={strings.PROFILE.ACCESS.OPTION}
              onBlur={onBlur}
              onChange={onChange}
              value={value as string}
              options={directReportOptions}
            />
          )}
        />
      </Grid>

      <Hidden xsDown>
        <Grid sm={6} item />
      </Hidden>
    </>
  )
}

export default WorkHiddenFields
